import Vue from "vue";
import "./plugins/filters.js";
import VueGtag from "vue-gtag";
import "./plugins/globalVariable.js";
import "./plugins/globalComponent.js";
import { BootstrapVue } from "bootstrap-vue";
import "../public/customstyle.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-icons/font/bootstrap-icons.css";

Vue.use(BootstrapVue);

Vue.use(VueGtag, {
  config: { id: "G-B3BTM7EWVZ" },
});

import VueSanitize from "vue-sanitize";
Vue.use(VueSanitize);

import VueTour from "vue-tour";
require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);

import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);

import Embed from "v-video-embed";
Vue.use(Embed);

import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

import Tooltip from "vue-directive-tooltip";
import "vue-directive-tooltip/dist/vueDirectiveTooltip.css";
Vue.use(Tooltip);

import VueNativeNotification from "vue-native-notification";

Vue.use(VueNativeNotification, {
  requestOnNotify: true,
});

import VueSocketIO from "vue-socket.io";

import Axios from "axios";
Vue.prototype.$http = Axios;

import $ from "jquery";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;
Vue.prototype.$ = $;

import cookie from "js-cookie";
Vue.prototype.$cookie = cookie;

import IdleVue from "idle-vue";
const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 60000 * 9, // 10 menit,
  startAtIdle: false,
});

import store from "./store";
Vue.prototype.$store = store;

let token_refresh = cookie.get("medmon_refresh");
if (token_refresh) {
  store
    .dispatch("setLogin")
    .then((token) => {
      if (token) {
        Vue.prototype.$.ajaxSetup({
          headers: { token: token },
        });
      } else {
        store
          .dispatch("renewToken")
          .then((token) => {
            Vue.prototype.$.ajaxSetup({
              headers: { token: token },
            });
          })
          .catch((error) => {
            console.log(error);
            store.dispatch("logout");
            location.reload();
          });
      }
    })
    .catch(() => {
      store.dispatch("logout");
    });
}

Vue.use(
  new VueSocketIO({
    debug: false,
    connection: process.env.VUE_APP_SOCKET_URL,
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
  })
);

import App from "./App.vue";
import titleMixin from "./plugins/titleMixin";

var coreLayout = "#apps";

Vue.mixin(titleMixin);

Vue.config.productionTip = false;

import router_kurasi from "./router/index.js";
import router_kabayan from "./router/router_kabayan.js";

let router = router_kurasi;
if ("project" in store.getters.user) {
  if (store.getters.user.project) {
    if ("project_detail" in store.getters.user.project) {
      if ("tipe" in store.getters.user.project.project_detail) {
        if (store.getters.user.project.project_detail.tipe == 2) {
          router = router_kabayan;
        }
      }
    }
  }
}

new Vue({
  router,
  render: (h) => h(App),
}).$mount(coreLayout);
